import get from 'lodash/get';
import { getUserType, getUserStatus } from './helpers';

export const userEvent = (user, data) => {
  const uuid = get(user, 'uuid');
  const isTechnicalUser = get(data, 'isTechnicalUser');
  const paa = get(data, 'paa');
  const ia = get(data, 'ia');
  const userType = getUserType(paa, ia);
  const dsCode = get(data, 'code');
  const userStatus = dsCode ? getUserStatus(dsCode) : 'onboarded';

  return {
    uuid,
    isTechnicalUser,
    userType,
    userStatus,
  };
};
